var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',{attrs:{"transform":_vm.transformText}},_vm._l((_vm.cardPos),function(card,idx){return _c('DoKoStackCards',{key:idx,attrs:{"x":card.x,"y":card.y,"rotate":card.r}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }